import { radioCardStyles } from './radio-card.styles';
import { NatGenRadio } from '../radio/radio';
import { radioCardTemplate } from './radio-card.template';
import { checkIcon, minusIcon } from '../../styles/icons';
import { NatGenDesignSystem } from '../../natgen-design-system';
import { RadioOptions } from '../radio/radio.options';
import { StartEnd, StartEndOptions } from '../start-end/start-end';
import { applyMixins } from '../../foundation/apply-mixins';
import { DocumentMediaSizeMixin, MediaSize, mediaSizes } from '../../utilities/media-size-observer';
import { observable } from '@microsoft/fast-element';
import { css } from 'lit';
import { selectableCardStyles } from '../../styles/patterns/selectable-card';
import { cardStyles } from '../card/card.styles';
import { checkboxCardTemplate } from '../checkbox-card/checkbox-card.template';
import { checkboxStyles } from '../checkbox/checkbox.styles';
import { checkboxTemplate } from '../checkbox/checkbox.template';
import { radioTemplate } from '../radio/radio.template';
import { radioStyles } from '../radio/radio.styles';

export type RadioCardOptions = RadioOptions & StartEndOptions;

/**
 * @element natgen-radio-card
 */
export class NatGenRadioCard extends NatGenRadio {

}

export const natGenRadioCardDefinition = NatGenRadioCard.compose({
    name: `${NatGenDesignSystem.prefix}-radio-card`,
    template: radioCardTemplate({
        checkedIndicator: checkIcon
    }),
    styles: radioCardStyles
});

applyMixins(NatGenRadioCard, StartEnd);

export class NatGenResponsiveRadio extends DocumentMediaSizeMixin(NatGenRadioCard) {
    documentMediaSizeChanged(newValue: MediaSize, oldValue: MediaSize): void {
        if (mediaSizes.indexOf(this.documentMediaSize) >= mediaSizes.indexOf('small')) {
            this.$fastController.addStyles(cardStyles);
            this.$fastController.addStyles(selectableCardStyles);
            this.$fastController.template = radioCardTemplate({
                    checkedIndicator: checkIcon
                });
        }
        else {
            this.$fastController.removeStyles(cardStyles);
            this.$fastController.removeStyles(selectableCardStyles);
            this.$fastController.template = radioTemplate({
                    checkedIndicator: checkIcon
                });
        }
    }

    @observable
    template: any;
}

export const natGenResponsiveRadioDefinition = NatGenResponsiveRadio.compose({
    name: `${NatGenDesignSystem.prefix}-responsive-radio`,
    styles: radioStyles
});
